import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WaiterTable } from '../../../interfaces/table';
import { IRestaurantInfo } from '../../../interfaces/restaurant';

@Component({
  selector: 'app-element-tables-list',
  templateUrl: './element-tables-modal.component.html',
  styleUrls: ['./element-tables-modal.component.scss']
})
export class ElementTablesModalComponent {

  public type!: 'waiter' | 'restaurant';
  public tables: WaiterTable[] = [];
  public restaurantIds: number[] = [];
  public name = '';
  public restaurantNames: { [p: number]: string } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {

    if (data.type === 'waiter') {
      this.type = 'waiter';
      this.tables = data.tables;
      this.name = data.waiterName;
    } else {
      this.type = 'restaurant';
      this.restaurantIds = data.restaurants;
      this.restaurantNames = data.restaurantsNames;
      this.name = data.name;
    }

  }

}
